/**
 * Components
 */
import Header from "components/Header";
import Footer from "components/Footer";
import Form from "components/Form";

/**
 * Crée la vue de la page contact.
 * @returns La page contact.
 */
function Contact() {
    return (
        <div className="contact">
            <Header />
            <main className="contact-main">
                <section className="contact-main-background">
                    <img src={require("assets/images/boutique_entree.jpg")} alt="La boutique vape&phone | orthez" />
                </section>
                <section className="contact-main-form">
                    <h2>Obtenir un devis</h2>
                    <p>Nous vous répondons en moins de 48H !</p>
                    <Form />
                </section>
            </main>
            <Footer />
        </div>
    )
}

export default Contact;